<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Müşteri</label>
            <v-select-list v-model="customerUser" label="FullName" placeholder="Müşteri" :options="customerUsers"/>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Ödeme Miktarı</label>
            <v-currency-input input-class="text-right currency-font-size" :value="value.TotalAmount" v-on:updateValue="v => value.TotalAmount = v"></v-currency-input>
        </div>
        <div class="col-12" v-if="!value.fromHome">
            <b-form-checkbox v-model="value.CanInstallment">Taksit Yapılabilir</b-form-checkbox>
        </div>
        <div class="col-12 mt-1">
            <label>Açıklama</label>
            <b-form-textarea  v-model="value.Description"></b-form-textarea>
        </div>
    </div>
</template>

<script>
import VCurrencyInput from '@/components/VCurrencyInput.vue'
import { BFormCheckbox,BFormTextarea } from 'bootstrap-vue'
import {UserApi} from '@/api/user'
export default {
    props:{
        value:Object
    },
    data(){
        return{
            customerUsers:[]
        }
    },
    components: { 
        VCurrencyInput,
        BFormCheckbox,
        BFormTextarea
    },
    mounted(){
        this.GetCustomerUser()
    },
    methods:{
        GetCustomerUser(){
            UserApi.CustomerList().then(res => {
                this.customerUsers = res.data.Data
            }).catch(err=>{
                console.log(err)
            })
        }
    },
    computed:{
        customerUser:{
            get:function(){
                return this.customerUsers.find(b=>b.Id==this.value.CustomerUserId)
            },
            set:function(value){
                this.value.CustomerUserId = value?.Id || null
            }
        }
    }
}
</script>

<style>

</style>